import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { selectMotif } from "../../actions/";
import { motifs } from "../config/";

const renderOption = option => {
  const { value, label } = option;
  return (
    <option key={value} value={value}>
      {label}
    </option>
  );
};

class SelectMotif extends Component {
  constructor(props) {
    super(props);
    this.onMotifChange = this.onMotifChange.bind(this);
    this.options = [
      { value: motifs.QUADRILLAGE, label: "Quadrillée" },
      { value: motifs.POINTS, label: "Pointée" }
    ];
  }

  onMotifChange(e) {
    this.props.selectMotif(e.target.value);
  }
  render() {
    return (
      <select
        className="form-control btn-info"
        onChange={this.onMotifChange}
        value={this.props.motif}
        title="Choisir le motif de la feuille : quadrillée ou pointée ?"
      >
        {this.options.map(renderOption)}
      </select>
    );
  }
}

SelectMotif.propTypes = {
  selectMotif: PropTypes.func.isRequired,
  motif: PropTypes.string.isRequired
};
const mapStateToProps = ({ motif }) => ({ motif });
const mapDispatchToProps = dispatch =>
  bindActionCreators({ selectMotif }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SelectMotif);
